import { OrderProcessStatus } from '@helpers/Constants';

interface OrderProcessBottomSheetProps {
  onClose: () => void;
  name: string;
  productId?: number;
  onSelect: (id: number, productId?: number, productName?: string) => void;
}

export const OrderProcessBottomSheet: React.FC<
  OrderProcessBottomSheetProps
> = ({ onClose, name, productId, onSelect }) => {
  return (
    <>
      <div className="fixed z-10 inset-0 bg-black bg-opacity-40 flex justify-center items-end w-full h-full">
        <div className="bg-white rounded-t-2xl w-full p-6 shadow-lg transition-transform transform translate-y-0 max-h-[70vh] flex flex-col">
          <div className="flex justify-between items-center mb-4">
            <h1 className="font-semibold text-lg">Update status for {name}</h1>
            <div className="flex items-center gap-2">
              <div className="relative"></div>
              <button
                onClick={onClose}
                type="button"
                className="text-gray-600 hover:text-gray-900"
              >
                ✕
              </button>
            </div>
          </div>
          <div className="border border-b" />
          <div className="overflow-y-auto max-h-[60vh] space-y-3 mt-3 cursor-pointer">
            <div
              onClick={() => onSelect(OrderProcessStatus.INPROGRESS)}
              className="flex p-2 rounded-lg border shadow-lg w-full hover:bg-[#EDF4FC] hover:border-[#0059B9] bg-[#FFFEFA]"
            >
              <span>Start Processing</span>
            </div>
          </div>
          <div className="overflow-y-auto max-h-[60vh] space-y-3 mt-3 cursor-pointer">
            <div
              onClick={() =>
                onSelect(OrderProcessStatus.COMPLETED, productId, name)
              }
              className="flex p-2 rounded-lg border shadow-lg w-full hover:bg-[#EDF4FC] hover:border-[#0059B9] bg-[#FFFEFA]"
            >
              <span> Complete Processing</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
